/** One hour in milliseconds. */
export const HOUR_MS = 60 * 60 * 1000;
